import { Log } from '@/parsing/Log';
import { LogEntryType } from '@/parsing/LogEntry';

import { TimelineMarker, TimelineRow, TimelineRowGroup } from '../../TimelineData';
import { obtainFreeRowForMarker } from '../obtainFreeRowForMarker';
import { TimelineGeneratorContext } from '../TimelineGeneratorContext';

export function generateIosAnalyticsGroupFromLog(
  log: Log,
  ctx: TimelineGeneratorContext,
): TimelineRowGroup {
  const screenRows: TimelineRow[] = [];
  const eventRows: TimelineRow[] = [];

  for (const entry of log.entries) {
    if (entry.entryType !== LogEntryType.Generic) {
      continue;
    }
    if (entry.extra.generic?.module !== 'ANALYTICS') {
      continue;
    }

    let tooltipContent = entry.content;
    let textOnMarker = '';
    const tooltipSplit = tooltipContent.split('::');
    if (tooltipSplit.length === 3) {
      tooltipContent = `${tooltipSplit[0]} ${tooltipSplit[1]}`;
      textOnMarker = tooltipSplit[1];
    }

    const isScreen = tooltipContent.startsWith('LOGGED SCREEN');
    const isBugReportScreen = textOnMarker === 'Bug Report Button Tap';
    const marker: TimelineMarker = {
      markerId: ctx.nextMarkerId,
      logEntry: entry,
      startTimeMs: entry.date.getTime(),
      endTimeMs: undefined,
      fillColor: isBugReportScreen ? '#cf0202' : isScreen ? '#aaaaff' : '#cccc99',
      textOnMarker,
      textOnMarkerColor: isBugReportScreen ? '#820101' : isScreen ? '#333388' : '#888833',
      tooltipContent,
    };
    ctx.nextMarkerId += 1;

    const row = obtainFreeRowForMarker(isScreen ? screenRows : eventRows, marker);
    row.markers.push(marker);
  }

  const rowGroup: TimelineRowGroup = {
    name: 'Analytics',
    rows: screenRows.concat(eventRows),
    expanded: true,
  };
  return rowGroup;
}
